var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(_vm.isOnBreak)?_c('page-break'):[_c('page-header'),_c('main',{staticClass:"container"},[_c('router-view')],1),_c('page-footer')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }